<template>
  <div>
    <AAlert :alert="alert" :errorOnly="true"></AAlert>
    <v-form ref="form" @submit.prevent="submit" lazy-validation>
      <v-row
        class="mt-0 ml-0 mr-0 mb-4 pa-2 pt-4 white"
        justify="start"
        align="center"
        md="3"
        no-gutters
      >
        <v-col class="ma-0 pa-0">
          <v-select
            small
            dense
            outlined
            hide-details
            :items="locations"
            label="Location*"
            v-model="location"
            :rules="locationRules"
            class="ma-2 ml-5 mr-5"
          ></v-select>
        </v-col>
        <v-col class="ma-0 pa-0">
          <v-text-field
            dense
            outlined
            hide-details
            clearable
            label="Transfer Order ID*"
            :type="'text'"
            v-model="trackingOrderId"
            :rules="trackingOrderIdRules"
            ref="refId"
            class="ma-2 ml-5 mr-5"
            background-color="yellow lighten-5"
          ></v-text-field>
        </v-col>
        <v-col class="ma-0 pa-0 shrink">
          <v-btn type="submit" color="success" :loading="loading" align="center">
            <v-icon left>save</v-icon>Save
          </v-btn>
        </v-col>
        <v-col class="ma-0 pa-0 shrink">
          <v-btn color="primary" :disabled="loading" @click="resetForm" class="ml-2" text>
            <v-icon left>clear</v-icon>Clear
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-layout class="mt-2">
      <v-flex>
        <TrackingOrderLog ref="refLog"></TrackingOrderLog>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
import snackbarMixin from "../../mixins/snackbar";
import loadDropdownMixin from "../../mixins/loadDropdown";
import confirmDialogMixin from "../../mixins/ConfirmDialogMixin";
import CRUDFuncsMixin from "../../mixins/CRUDFuncs";
import TrackingOrderLog from "./components/log";
import AAlert from "../../components/AAlert";
import cartApi from "../../api/cart";

export default {
  name: "cartscan",
  mixins: [
    snackbarMixin,
    loadDropdownMixin,
    confirmDialogMixin,
    CRUDFuncsMixin
  ],
  components: {
    TrackingOrderLog,
    AAlert
  },
  data: () => ({
    model: "cartscanlog",
    locationRules: [v => !!v || "Location is required"],
    locations: [],
    location: undefined,
    trackingOrderIdRules: [v => !!v || (v !== undefined && v.length > 0) || "Tracking Id is required"],
    trackingOrderId: "",
    loading: false,
    alert: {}
  }),
  mounted() {
    this.loadDropdownItems2("locations", this.locations);
    this.$refs.refId.focus();
  },
  computed: {},
  methods: {
    resetForm() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.$refs.refId.focus();
      this.alert = {};
    },
    submit(event, createIfNotFound = true) {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.alert = {};
        cartApi.scanTo(this.params(createIfNotFound), data => {
          this.loading = false;
          this.alert = data;
          if (data.ok) {
            this.$refs.form.resetValidation();
            // clear cart ID to avoid accidental duplicate scan
            this.trackingOrderId = "";
            this.$refs.refLog.refresh();
          } else {
            if (data.d && data.d.itemNotFound) {
              this.confirmDialog(
                "Transfer Order with ID '" +
                  this.trackingOrderId +
                  "' is not found in system. Do you wish to add this now permenantly?",
                () => this.submit(null, true),
                () => this.snackbar("Transfer Order was not saved")
              );
            }
          }
          this.$refs.refId.focus();
        });
      } else {
        this.snackbarWarn("Please fill the highlighted fields");
      }
    },
    params(createIfNotFound) {
      return {
        name: this.trackingOrderId,
        locationId: this.location.id,
        createIfNotFound: createIfNotFound
      };
    }
  }
};
</script>


<style>
</style>

